<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import MeasurementUnitForm from "./components/MeasurementUnitForm.vue"

defineProps<{
  measurement_unit: {
    id: number
    name: string
    symbol: string
  }
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <MeasurementUnitForm
      mode="edit"
      title="MeasurementUnits/MeasurementUnitsEdit"
      subtitle="Atualize a unidade de medida global."
      :measurement-unit="measurement_unit"
      :errors="errors"
    />
  </AppShell>
</template>

